// This function allow to reference all chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"121":"vendor","792":"main"}[chunkId] || chunkId) + "." + {"121":"360b80ba1803a306f010","792":"043fe2db991025769b2e","908":"6b355121ec236334327d"}[chunkId] + ".bundle.js";
};